/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneNumberBody
 */
export interface PhoneNumberBody {
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberBody
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof PhoneNumberBody
     */
    nationalNumber: string;
}

/**
 * Check if a given object implements the PhoneNumberBody interface.
 */
export function instanceOfPhoneNumberBody(value: object): value is PhoneNumberBody {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('nationalNumber' in value) || value['nationalNumber'] === undefined) return false;
    return true;
}

export function PhoneNumberBodyFromJSON(json: any): PhoneNumberBody {
    return PhoneNumberBodyFromJSONTyped(json, false);
}

export function PhoneNumberBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumberBody {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'nationalNumber': json['nationalNumber'],
    };
}

export function PhoneNumberBodyToJSON(json: any): PhoneNumberBody {
    return PhoneNumberBodyToJSONTyped(json, false);
}

export function PhoneNumberBodyToJSONTyped(value?: PhoneNumberBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'countryCode': value['countryCode'],
        'nationalNumber': value['nationalNumber'],
    };
}

